<script lang="ts" setup>
  import { toRefs } from 'vue'
  import { reactive, ref } from 'vue'
  import { i18n } from '@/i18n'
  import api from '@/services/api'

  interface ICrewUser {
    email: string
    firstName: string
    fullName: string
    id: string
    lastName: string
    marketLocations: string[]
    phoneNumber: string
  }

  interface IProps {
    crewUser: ICrewUser
  }

  const props = defineProps<IProps>()
  const emit = defineEmits(['closeAddDialog'])
  const { crewUser } = toRefs(props)
  const { t } = i18n.global

  const loading = ref(false)
  const values = reactive({
    email: crewUser.value.email,
    phoneNumber: crewUser.value.phoneNumber,
    firstName: crewUser.value.firstName,
    lastName: crewUser.value.lastName,
  })

  const handleSubmit = async () => {
    loading.value = true
    const input = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      firstName: values.firstName,
      lastName: values.lastName,
    }
    await api.patch(`/Api/CrewUser/Update/${crewUser.value.id}`, input).then((response) => {
      console.log(response)
      emit('closeAddDialog')
      loading.value = false
    })
  }
</script>

<template>
  <form class="w-full" @submit.prevent="handleSubmit()">
    <div class="field">
      <label for="firstName">{{ t('crewUser.firstname') }}</label>
      <InputText id="firstName" v-model="values.firstName" type="text" class="w-full" />
    </div>

    <div class="field">
      <label for="lastname">{{ t('crewUser.lastname') }}</label>
      <InputText id="lastname" v-model="values.lastName" type="text" class="w-full" />
    </div>
    <div class="field">
      <label for="phoneNumber">{{ t('crewUser.phone') }}</label>
      <InputText id="phoneNumber" v-model="values.phoneNumber" type="text" class="w-full" />
    </div>
    <div class="field">
      <label for="email">{{ t('crewUser.email') }}</label>
      <InputText id="email" v-model="values.email" type="text" class="w-full" />
    </div>
    <div class="flex gap-3">
      <Button type="submit" class="w-full" icon-pos="right" :loading="loading" icon="pi pi-chevron-right" :label="t('crewUser.submit')" />
    </div>
  </form>
</template>
